export const hour24tohour12 = (hour) => {
    const h = Number(hour);
    if (isNaN(h) || h < 0 || h > 23) return null;

    if (h === 0)
        return h + 12 ;

    if (h >= 1 && h <= 11)
        return h ;

    if (h === 12)
        return h;

    if (h >= 13 && h <= 23)
        return h-12;

}

export const hour12tohour24 = (hour, type) => {
    const h = Number(hour);
    if (isNaN(h) || h < 1 || h > 12) return null;

    if (type === "PM" && h === 12)
        return h;

    if (type === "PM" && h >= 1 && h <= 11)
        return h + 12;

    if (type === "AM" && h === 12)
        return h - 12;

    if (type === "AM" && h >= 1 && h <= 11)
        return h;

    return null;
}


export const hour24tohour12GetPMAM = (hour) => {
    const h = Number(hour);
    if (isNaN(h) || h < 0 || h > 23) return null;

    if (h <= 11)
        return "AM" ;

    if (h >= 12)
        return "PM";
}